import React, { useState, useEffect, Fragment } from 'react';
import IntlMessages from '../../util/IntlMessages';
import { useReactOidc } from '@axa-fr/react-oidc-context';
// import styles  as styles from "./Fetch.css";
import LoadingSvg from '../../assets/images/loader.svg';

function FetchBpmNewCaseIframe(props: any) {
  const [objectUrl, setObjectUrl] = useState('');
  const [err, setErr] = useState(false);
  const { oidcUser } = useReactOidc();

  useEffect(() => {
    async function getImage(url: string) {
      try {
        const accessToken = oidcUser.access_token;
        // let token = await auth.getAccessToken();
        // let token ='eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJzdWIiOiJhZG1pbiIsIm5hbWUiOiJhZG1pbiIsInVybjpmZzp0IjoiY2JmMjRlOTEyOWUwNDU3ZDliMjRjM2EwZTJhZmFmNjAiLCJjbGllbnRfaWQiOiJzcGEiLCJhbXIiOlsicHdkIl0sImlkcCI6ImxvY2FsIiwic2NvcGUiOlsib3BlbmlkIiwicHJvZmlsZSIsImFwaSIsInJvbGVzIiwiZmFyYWdvc3Rhci1hcGkiXSwibmJmIjoxNjE0NTE3ODUxLCJleHAiOjE2MTQ1MTg3NTEsImlhdCI6MTYxNDUxNzg1MSwiaXNzIjoiaHR0cDovL2xvY2FsaG9zdC9kZXYiLCJhdWQiOiJzcGEifQ.7sG02_7YIYhdVMLlECspIRqYj7po4WZ2bXpUbRG8vCQ';
        // let token =`eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJzdWIiOiJhZG1pbiIsIm5hbWUiOiJhZG1pbiIsInVybjpmZzp0IjoiNWUxOGNlYmM3YmRjNGJiNWFlZGQ3YTg0NTkyY2ZmM2UiLCJjbGllbnRfaWQiOiJzcGEiLCJhbXIiOlsicHdkIl0sImlkcCI6ImxvY2FsIiwic2NvcGUiOlsib3BlbmlkIiwicHJvZmlsZSIsImFwaSIsInJvbGVzIiwiZmFyYWdvc3Rhci1hcGkiXSwibmJmIjoxNjE0NTIwNTIzLCJleHAiOjE2MTQ1MjE0MjMsImlhdCI6MTYxNDUyMDUyMywiaXNzIjoiaHR0cDovL2xvY2FsaG9zdC9kZXYiLCJhdWQiOiJzcGEifQ.GqPU2V1cFH274qfmUSpwVaOU_5_JpqTFDC3Z5uK5KuY`;

        const stringUrl = `${url}&token=${accessToken}&pwaBpmUrl=${window.location.origin}/team-work/instance?folder=Process-0`;
        setObjectUrl(stringUrl);
        // let data = res.data; // str

        // let blob = new Blob([data], {
        //   type: "text/html",
        // });

        // let blobUrl = URL.createObjectURL(blob);
        // setObjectUrl(blobUrl);
      } catch (error) {
        console.log('bpm: ', error);
        setErr(true);
      }
    }

    getImage(props.src);
  }, []);

  useEffect(() => {
    if (objectUrl !== '') return URL.revokeObjectURL(objectUrl);
  }, []);

  if (err) {
    return (
      <div>
        <IntlMessages id="messages.errorOccurInServer" />
      </div>
    );
  }

  const iframeStyles = {
    // marginTop: "4rem",
    width: '100%',
    // height: (9 * SCREEN_HEIGHT) / 10,
    height: '95vh',
  };

  return (
    <Fragment>
      {objectUrl ? (
        <iframe style={iframeStyles} src={objectUrl} scrolling="no"></iframe>
      ) : (
        <img className="" src={LoadingSvg} />
      )}
    </Fragment>
  );
}

export default FetchBpmNewCaseIframe;
